






























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { CURRENCY_FORMAT } from "@/helpers/currency";
import cCard from "@/components/default/Card.vue";
import cDatagrid from "@/components/default/Datagrid.vue";

import notificationService from "@/services/notificationService";
import subcontractorRepository from "@/services/subcontractorsRepository";

import Contact from "@/classes/CRM/Contact";
import LinkContactDialog from "@/components/crm/shared/LinkContactDialog.vue";
import ContactDialog from "@/components/crm/ContactDialog.vue";
import contactsRepository from "@/services/contactsRepository";

@Component({
  components: {
    cCard,
    cDatagrid,
    LinkContactDialog,
    ContactDialog,
  },
})
export default class CompanyEmployeesCard extends Vue {
  @Prop({ required: true })
  public company!: ICompany;

  @Prop({ required: false, default: false })
  public isSubcontractor!: boolean;

  public contacts: IContact[] = [];
  public teams: string[] = [];

  mounted() {
    this.loadData();
  }

  async loadData() {
    if (this.company && this.company.id) {
      this.contacts = (await contactsRepository.getRelations(this.company.id)).data.filter((o: IBasicContact) => o.type === "Contact");
    }
  }

  linkContact() {
    (this.$refs.linkContactDialog as LinkContactDialog).show = true;
    (this.$refs.linkContactDialog as LinkContactDialog).formData.contactA = this.company.id as string;
  }

  addContact() {
    (this.$refs.contactDialog as ContactDialog).contactId = null;
    (this.$refs.contactDialog as ContactDialog).show = true;
  }

  editContact(e: any) {
    if (e.column && e.column.type !== "buttons" && e.data && e.data.id && !e.row.isEditing) {
      (this.$refs.contactDialog as ContactDialog).contactId = e.data.id;
      (this.$refs.contactDialog as ContactDialog).show = true;
    }
  }

  saveUpdates(e: any) {
    const self = this;
    e.cancel = new Promise((resolve, reject) => {
      try {
        const contact = Object.assign(new Contact(), e.data) as Contact;
        contact.save();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  async deleteContact(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        if (self.company.id) {
          await contactsRepository.RemoveRelation(self.company.id, e.data.id);
          // (await subcontractorRepository.removeEmployee(self.company.id, e.data.id));
        }
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  get columns() {
    const self = this;
    const cols: any[] = [
      {
        dataField: "displayName",
        caption: this.$t("objects.contacts.Fields.DisplayName"),
        allowEditing: false,
      },
      {
        dataField: "jobTitle",
        caption: this.$t("objects.contacts.Fields.JobTitle"),
      },
      {
        dataField: "email",
        caption: this.$t("objects.contacts.Fields.Email"),
      },
      {
        dataField: "phone",
        caption: this.$t("objects.contacts.Fields.Phone"),
      },
      /*{
            dataField: 'hourlyRate',
            caption: this.$t('objects.subcontractors.fields.HourlyRate'),
            format: CURRENCY_FORMAT,
            alignment: 'left',
        },*/
      {
        type: "buttons",
        buttons: ["edit", "delete"],
      },
    ];

    if (this.isSubcontractor) {
      cols.push({
        dataField: "team",
        caption: this.$t("objects.contacts.Fields.Team"),
        lookup: {
          dataSource: (self.company as ISubcontractor).teams !== undefined ? (self.company as ISubcontractor).teams : [],
          displayExpr: "name",
          valueExpr: "name",
        },
      });
    }

    return cols;
  }
}
